enum ValidationResult{
  Equals = 1,
  Unequals = 2,
  Undefined = 3
}

export default ValidationResult;
